import { Routes } from '@angular/router';
import { BulkPickingEnabledGuard } from '@/shared/guards/bulk-picking-enabled.guard';

export const pickingRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./picking.component').then((m) => m.PickingComponent),
    canActivate: [BulkPickingEnabledGuard],
  },
  {
    path: 'crate/:id',
    loadComponent: () => import('./picking-flow/picking-flow.component').then((m) => m.PickingFlowComponent),
  },
];
